export default function AboutHero() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/AboutHero.jpg"
          alt="Ester LifeSciences Laboratory"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
          About Ester LifeSciences
        </h1>
        <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          Committed to Excellence in Pharmaceutical Care
        </p>
      </div>
    </section>
  );
}
